module.exports = __webpack_public_path__ + "static/logo_consult-4aa24541d723085acda29421842d711a.png";